/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Destination configuration for BigQuery native PITR restore.
*/
export class BigQueryNativePitrDestination {
  /**
  * Target dataset ID where restored tables will be created.
  */
  'datasetId': string;
  /**
  * BigQuery location for the target dataset (e.g., \"US\", \"EU\", \"us-central1\"). Defaults to the source dataset location if not specified. 
  */
  'location'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "datasetId",
      "baseName": "datasetId",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BigQueryNativePitrDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

